"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var consola_1 = tslib_1.__importDefault(require("consola"));
var default_1 = /** @class */ (function () {
    function default_1(queueId, invoker) {
        this.queueId = queueId;
        this.invoker = invoker;
        this.queue = [];
    }
    default_1.prototype.process = function (chain) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                consola_1.default.trace("Invoker: Queue: Enqueuing " + chain.commandType + " to " + this.queueId + "..");
                this.queue.push(chain);
                if (this.queue.length > 1) {
                    consola_1.default.log('Invoker: Queue: Already processing..');
                    return [2 /*return*/];
                }
                this.internalProcess();
                return [2 /*return*/];
            });
        });
    };
    default_1.prototype.internalProcess = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var current, receiver, ctx, result, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.queue.length > 0)) return [3 /*break*/, 5];
                        current = this.queue[0];
                        receiver = current.receivers.shift();
                        if (!receiver) return [3 /*break*/, 4];
                        // Execute receiver and update chain result
                        consola_1.default.trace("Invoker: Queue: Executes receiver for " + current.commandType + " in " + this.queueId + "..");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        ctx = Object.create(this.invoker);
                        ctx.break = function () {
                            current.receivers = [];
                        };
                        return [4 /*yield*/, receiver.apply(ctx, [current.command, current.result])];
                    case 2:
                        result = _a.sent();
                        if (typeof result !== 'object' && typeof result !== 'undefined') {
                            throw 'Receivers are expected to return object or undefined';
                        }
                        current.result = tslib_1.__assign(tslib_1.__assign({}, current.result), result);
                        current.next();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        current.onFail(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.queue.shift();
                        consola_1.default.trace("Invoker: Queue: Removed chain from queue " + this.queueId + ", current length: " + this.queue.length);
                        return [3 /*break*/, 0];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=queue.js.map